module.exports = __webpack_public_path__ + "img/number.371e9479.svg";